function BlotterText(){

    this.build();
    this.start = null;

}

BlotterText.prototype.build = function(){

    let splitText = new SplitText($('.title-blotter'), {
        type: "lines",
        linesClass : "blotter-lines"
    });

    let pointRadiusStart = 0.1;
    let pointRadiusEnd = 0.7;

    let ratio = (window.devicePixelRatio > 1) ? 2 : 1;
    let uPointCellWidth = 0.01 / ratio;

    let fontSize = window.innerWidth * 0.15 * ratio;

    $(".blotter-lines").each(function(){

        let line = $(this);
        let txt = line.html();
        let text = new Blotter.Text(  txt.trim(), {
            family: "'MADESAONARA', serif",
            size : fontSize,
            fill : "#ffffff",
            leading: 1
        });

        let material = new Blotter.FliesMaterial();
        material.needsUpdate = true;
        material.uniforms.uPointCellWidth.value = uPointCellWidth;
        material.uniforms.uPointRadius.value = pointRadiusStart;
        material.uniforms.uSpeed.value = 2;

        let blotter = new Blotter(
            material,
            {
                texts : text,
                // ratio : 0.5
            }
        );

        let scope = blotter.forText(text);

        scope.appendTo( $('.blotter-text') );

        requestAnimationFrame(Radius);
        // requestAnimationFrame(Cell);

        // let pointRadiusStart = 0.1;
        // let pointRadiusEnd = 0.7;
        //
        // let pointCellStart = 0.1;
        // let pointCellEnd = 0.009;

        function Radius(){
            pointRadiusStart += 0.007;
            if( pointRadiusStart < pointRadiusEnd ) {
                material.uniforms.uPointRadius.value =  pointRadiusStart;
                requestAnimationFrame(Radius);
            }
        }

        // function Cell(){
        //     pointCellStart -= 0.001;
        //     if( pointCellStart > pointCellEnd ) {
        //         material.uniforms.uPointCellWidth.value =  pointCellStart;
        //         // console.log(pointCellStart + " : " + pointCellEnd);
        //         requestAnimationFrame(Cell);
        //     }
        // }

    });

    // let that = this;
    //
    // // let radius = 1;
    // // let cell = 0.02;
    //
    // let radius = 0.75;
    // let cell = 0.005;
    //
    // let txt = $('.blotter-text').data('text');
    //
    // let text = new Blotter.Text(txt, {
    //     family: "serif",
    //     size : 220,
    //     fill : "#ffffff"
    // });
    //
    // let material = new Blotter.FliesMaterial();
    // material.needsUpdate = true;
    // // material.uniforms.uPointCellWidth.type = "2f";
    // material.uniforms.uPointCellWidth.value =  cell;
    // material.uniforms.uPointRadius.value = radius;
    // material.uniforms.uSpeed.value = 1;
    //
    // let blotter = new Blotter(
    //     material,
    //     {
    //         texts : text,
    //         // ratio : 0.5
    //     }
    // );
    //
    // let scope = blotter.forText(text);
    //
    // scope.appendTo( $('.blotter-text') );

    // scope.appendTo($('.botter-text'));

};

BlotterText.prototype.animate = function(){



};
